import { ToastManagerRepository } from "@iot-platform/core";
import { Users } from "@user/domain/models/user.model";
import type { UserRepository } from "@user/domain/repositories/user.repository";
import { userTypes } from "@user/root/user-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class UserGetAllResumeUseCase {
    constructor(
        @inject(userTypes.repositories.UserRepository)
        private readonly userRepository: UserRepository,
    ) {}

    async execute(): Promise<Users> {
        const usersResult = await this.userRepository.getAllResume();

        if (usersResult.isErr()) {
            const error = usersResult.error.message;

            ToastManagerRepository.error(error);
        }

        return usersResult.match(
            (users) => users,
            () => Users.empty(),
        );
    }
}
